export default function stringDelimiter(strInput) {
  return strInput.replace(/['"]+/g, '')
}
